<script>
import { EventBus } from '@/helpers/eventBus'

export default {
  props: {
    user: {
      type: Object
    },
    current: {
      type: String
    },
    list: {
      type: Array
    },
    disabled: {
      type: Boolean
    },
    invoiceRoles: {
      type: Array
    }
  },
  data() {
    return {
      localCurrent: this.current,
      notification: {
        state: false,
        message: '',
        type: 'success'
      },
    }
  },
  computed: {
    payload() {
      let payload = {}
      if (this.user) {
        payload = {
          userId: this.user.id,
          roleName: this.localCurrent
        }
      }
      return payload
    }
  },
  watch: {
    current(newVal) {
      this.localCurrent = newVal;
    }
  },
  methods: {
    toggleCredential() {
      this.loading = true
      this.$backofficeService.changeUniqueRoleFromUser(this.payload)
      .then(() => {
        this.$emit('updated:role', this.localCurrent)
        this.notification.message = this.$t('component.backoffice.uniqueRoleSelected.entry.changed')
        this.notification.type = 'success'
      })
      .catch(() => {
        this.notification.message = this.$t('component.backoffice.uniqueRoleSelected.warning')
        this.notification.type = 'error'
      })
      .finally(() => {
        this.notification.state = true
        EventBus.$emit('backoffice_notification', this.notification)
        this.dialog = false
        this.loading = false
      })
    },
    canToggleCredential(credentialName) {
      if (!this.user.aplId && this.invoiceRoles.includes(credentialName)) {
        return false
      }
      return true
    },
  }
}
</script>
<template>
  <v-container>
    <v-radio-group v-model="localCurrent">
      <table
        class="elevation-0"
      >
        <thead>
        <tr>
          <th style="height: 0px; width: 70px; border-bottom: 0px"></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item,index) in list" :key="index">
          <td>
            <v-tooltip
              v-if="!canToggleCredential(item)"
              top>
              <template #activator="{ on, attrs }">
                <v-icon
                  color="red"
                  v-bind="attrs"
                  v-on="on"
                >mdi-information</v-icon
                >
              </template>
              <span>{{$t('component.backoffice.uniqueRoleSelected.apl.id.missing')}}</span>
            </v-tooltip>
            <v-radio
              v-else
              :value="item"
              :disabled="
                  !canToggleCredential(item)"
              @click="toggleCredential"
            ></v-radio>
          </td>
          <td>
            <label>{{ item }}</label>
          </td>
        </tr>
        </tbody>
      </table>
    </v-radio-group>
  </v-container>
</template>
<style scoped>
label {
  font-size: 14px;
  color: #000000de;
}
.v-radio, .v-icon{
  margin-left: 3px;
}
</style>
